import { render, staticRenderFns } from "./hours.vue?vue&type=template&id=4f1d0a6e"
import script from "./hours.vue?vue&type=script&lang=js"
export * from "./hours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f1d0a6e')) {
      api.createRecord('4f1d0a6e', component.options)
    } else {
      api.reload('4f1d0a6e', component.options)
    }
    module.hot.accept("./hours.vue?vue&type=template&id=4f1d0a6e", function () {
      api.rerender('4f1d0a6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/mail/hours.vue"
export default component.exports